module.exports = __webpack_public_path__ + "img/FR30003.631f59dc.png";